module.exports = __webpack_public_path__ + "media/images/favicons/favicon-32x32-4368648a88049af6bc8adf6e56d9f106.png";